import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import StartLayout from '../layouts/StartLayout';
import { isLoggedIn } from '../utils/auth';

export default function PublicRoute() {
    return isLoggedIn() ? (
        <Navigate to={'/dashboard'} />
    ) : (
        <StartLayout>
            <Outlet />
        </StartLayout>
    );
}
